import React, { useEffect, useState } from "react";
import Button from "../../shared/Button";
import swal from "sweetalert";
import { Spinner } from "reactstrap";
import CustomModal from "../../shared/CustomModal";
import Select from "../../shared/Select";

const AssignTeacherRow = ({
  classroom,
  staffListOptions,
  subjectId,
  insertSubjectClassroomTeacher,
  deleteSubjectClassroomTeacher,
  loading,
}) => {
  const [teachers, setTeachers] = useState(null);
  const [editTeacher, setEditTeacher] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [unAsssignedTeacher, setUnAsssignedTeacher] = useState(null);
  const [selectedRowClasroomId, setSelectedRowClassroomId] = useState(null);

  const validateTeacherAssignment = () => {
    if (!editTeacher) {
      setEditTeacher(true);
      return;
    }

    if (!teachers || teachers.length === 0) {
      swal("Oops", "Please select at least one teacher");
      return;
    }

    const params = {
      yearLevelId: classroom?.yearLevelId,
      classroomId: classroom?.id,
      educationLevelId: classroom?.educationLevelId,
      educationLevelDivisionId: classroom?.educationLevelDivisionId,
      subjectId: subjectId,
    };

    handleAssignTeacher(params);
  };

  const handleAssignTeacher = (params) => {
    const payload = (teachers || [])?.map((item) => ({
      ...params,
      subjectTeacherRecruitmentId: item.value,
    }));

    insertSubjectClassroomTeacher(payload);
    setEditTeacher(false);
  };

  const handleDelete = () => {
    if (!unAsssignedTeacher || unAsssignedTeacher?.length === 0) {
      return;
    }

    const params = {
      yearLevelId: classroom?.yearLevelId,
      classroomId: classroom?.id,
      subjectId: subjectId,
    };

    const payload = unAsssignedTeacher?.map((item) => ({
      ...params,
      subjectTeacherRecruitmentId: item?.value,
    }));

    deleteSubjectClassroomTeacher(payload);

    if (!loading.delete) {
      setDeleteModal(false);
      setUnAsssignedTeacher(null);
    }
  };

  useEffect(() => {
    const newTeachers = classroom?.subjectClassroomTeachers?.map((item) => ({
      label: item?.peopleName,
      value: item?.subjectTeacherRecruitmentId,
    }));

    setTeachers(newTeachers);

    if (newTeachers?.length > 0) {
      setEditTeacher(false);
    }
  }, [classroom?.subjectClassroomTeachers]);

  return (
    <>
      <tr>
        <td style={{ whiteSpace: "nowrap" }}>{classroom.name}</td>
        <td>
          {editTeacher ? (
            <Select
              name={"staffList"}
              options={staffListOptions}
              value={teachers}
              onChange={(option) => {
                const newOption = option || [];

                if (
                  classroom?.subjectClassroomTeachers?.length > 0 &&
                  teachers?.length > newOption?.length
                ) {
                  const unassignedTeacher = (teachers || [])?.filter(
                    (item) =>
                      !newOption?.some((opt) => opt.value === item.value),
                  );

                  setDeleteModal(true);
                  setUnAsssignedTeacher(unassignedTeacher);
                  return;
                }

                setTeachers(option || []);
              }}
              isMulti={true}
              isSearchable={true}
              styles={{
                control: {
                  width: "300px",
                },
              }}
            />
          ) : !editTeacher || teachers?.length > 0 ? (
            <div className="flex" style={{ flexWrap: "wrap", gap: "8px" }}>
              {teachers?.map((item) => (
                <div className="arr-badge" key={item?.value}>
                  {item?.label}
                </div>
              ))}
            </div>
          ) : null}
        </td>
        <td>
          <div className="action-btns">
            {editTeacher && classroom?.subjectClassroomTeachers?.length > 0 && (
              <Button
                variant="outline"
                onClick={() => setEditTeacher(false)}
                size="sm"
              >
                Cancel
              </Button>
            )}
            <Button
              disabled={loading.create}
              onClick={() => {
                setSelectedRowClassroomId(classroom?.id);
                validateTeacherAssignment();
              }}
              size="sm"
              ariaLabel="assign-teacher"
            >
              {loading.create && classroom?.id === selectedRowClasroomId ? (
                <Spinner size={"sm"} color="white" />
              ) : (
                "Assign Teacher"
              )}
            </Button>
          </div>
        </td>
      </tr>

      <CustomModal
        isOpen={deleteModal}
        toggle={() => setDeleteModal(false)}
        modalHeader={"Are you sure?"}
        children={
          <div>
            <p>Once deleted, you will not be able to recover this record</p>
            <div className="action-btns end">
              <Button variant="outline" onClick={() => setDeleteModal(false)}>
                Cancel
              </Button>
              <Button
                variant="danger"
                disabled={loading.delete}
                onClick={handleDelete}
              >
                {loading.delete ? (
                  <Spinner size={"sm"} color="white" />
                ) : (
                  "Delete"
                )}
              </Button>
            </div>
          </div>
        }
      />
    </>
  );
};

export default AssignTeacherRow;
